'use strict';

var _createClass = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _classCallCheck = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ErrorReportingMixinBase = require('./mixin-base');
var ErrorReportingPreprocessorMixin = require('./preprocessor-mixin');
var Mixin = require('../../utils/mixin');
var ErrorReportingTokenizerMixin = /*#__PURE__*/function (_ErrorReportingMixinB) {
  function ErrorReportingTokenizerMixin(tokenizer, opts) {
    var _this;
    _classCallCheck(this, ErrorReportingTokenizerMixin);
    _this = _callSuper(this, ErrorReportingTokenizerMixin, [tokenizer, opts]);
    var preprocessorMixin = Mixin.install(tokenizer.preprocessor, ErrorReportingPreprocessorMixin, opts);
    _this.posTracker = preprocessorMixin.posTracker;
    return _this;
  }
  _inherits(ErrorReportingTokenizerMixin, _ErrorReportingMixinB);
  return _createClass(ErrorReportingTokenizerMixin);
}(ErrorReportingMixinBase);
module.exports = ErrorReportingTokenizerMixin;